import { faBookSpells } from '@fortawesome/pro-duotone-svg-icons';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import {
  EmptyState,
  EmptyStateContainer,
  EmptyStateIcon,
} from 'components/atoms/empty-state';
// import { KBLinks, RoutePaths } from 'constant';
import { RoutePaths } from 'constant';

export const DocumentTemplatesEmptyState: FC = () => (
  <EmptyStateContainer>
    <EmptyState
      data-cy="templates.create-new"
      image={<EmptyStateIcon icon={faBookSpells} />}
      title={<FormattedMessage id="document_templates.empty.title" />}
      message={<FormattedMessage id="document_templates.empty.message" />}
      primaryCTA={
        <Link to={RoutePaths.newDocumentTemplate}>
          <EmptyState.CallToAction.Primary>
            <FormattedMessage id="document_templates.empty.primary" />
          </EmptyState.CallToAction.Primary>
        </Link>
      }
      // secondaryCTA={
      //   <EmptyState.CallToAction.Secondary
      //     href={KBLinks.projectPlanTemplate}
      //     target="_blank"
      //   >
      //     <FormattedMessage id="document_templates.empty.secondary" />
      //   </EmptyState.CallToAction.Secondary>
      // }
    />
  </EmptyStateContainer>
);
